import type {
  DailyMissionCompleteToggleResponse,
  DailyMissionDateRangeParams,
  DailyMissionDateRangeResponse,
  DailyMissionResponse
} from './model/dailyMissionType'

import { jwtClientAxios } from '.'

import api from '@/api/url'

export const getDailyMissionApi = async (target_date: string): Promise<DailyMissionResponse> => {
  const response = await jwtClientAxios().get(api.dailyMission.GET_DAILY_MISSION(target_date))
  return response.data
}

export const getDailyMissionCompleteToggleApi = async (
  daily_mission_id: string
): Promise<DailyMissionCompleteToggleResponse> => {
  const response = await jwtClientAxios().post(api.dailyMission.COMPLETE_TOGGLE(daily_mission_id))
  return response.data
}

export const getDailyMissionDateRangeApi = async (
  params: DailyMissionDateRangeParams
): Promise<DailyMissionDateRangeResponse> => {
  const response = await jwtClientAxios().get(api.dailyMission.DATE_RANGE, { params })
  return response.data
}
